/**
 * @generated SignedSource<<71bcd881b8a82dbc5d31816778a9fc3d>>
 * @relayHash 5ddb02c76b4394774d122c19b1a2f305
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a1e4e783d8386ff13d97403e41b5c3dca0baeeec0fbf0f45b8725f8dda3d2d29

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { TeamActivitySpikeAppMemoQuery } from './TeamActivitySpikeAppMemoQuery.graphql';

const node: PreloadableConcreteRequest<TeamActivitySpikeAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a1e4e783d8386ff13d97403e41b5c3dca0baeeec0fbf0f45b8725f8dda3d2d29",
    "metadata": {},
    "name": "TeamActivitySpikeAppMemoQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
